module.exports = {
	"Play": "Tocar",
	"Pause": "Pausar",
	"Current Time": "Tempo",
	"Duration Time": "Duração",
	"Remaining Time": "Tempo Restante",
	"Stream Type": "Tipo de Stream",
	"LIVE": "AO VIVO",
	"Loaded": "Carregado",
	"Progress": "Progresso",
	"Fullscreen": "Tela Cheia",
	"Non-Fullscreen": "Tela Normal",
	"Mute": "Mudo",
	"Unmute": "Habilitar Som",
	"Playback Rate": "Velocidade",
	"Subtitles": "Legendas",
	"subtitles off": "Sem Legendas",
	"Captions": "Anotações",
	"captions off": "Sem Anotações",
	"Chapters": "Capítulos",
	"You aborted the media playback": "Você parou a execução do vídeo.",
	"A network error caused the media download to fail part-way.": "Um erro na rede fez o vídeo parar parcialmente.",
	"The media could not be loaded, either because the server or network failed or because the format is not supported.": "O vídeo não pode ser carregado, ou porque houve um problema com sua rede ou pelo formato do vídeo não ser suportado.",
	"The media playback was aborted due to a corruption problem or because the media used features your browser did not support.": "A execução foi interrompida por um problema com o vídeo ou por seu navegador não dar suporte ao seu formato.",
	"No compatible source was found for this media.": "Não foi encontrada fonte de vídeo compatível."
};


//////////////////
// WEBPACK FOOTER
// ./~/vue-video-player/lang/pt-BR.json
// module id = 260
// module chunks = 81